var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand__State=Expand, Type=Default",
    className: "expand__State=Expand, expand__Type=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand__Vector 209 (Stroke)",
    fill: "#919EAB",
    fillRule: "evenodd",
    d: "M16.944 6.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75Zm-6.371 1.318a.75.75 0 0 1 1.06.01l3.677 3.75a.75.75 0 0 1 .032 1.015l-3.676 4.264a.75.75 0 0 1-1.136-.98l2.607-3.024H7.055a.75.75 0 0 1 0-1.5h5.933L10.562 8.63a.75.75 0 0 1 .01-1.061Z",
    className: "expand__Vector expand__209 expand__(Stroke)",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsExpand);
export default __webpack_public_path__ + "static/media/sidebar-icons-expand.ace4a95720775d96223018d9050a5a43.svg";
export { ForwardRef as ReactComponent };